<template>
  <section v-if="users" class="bg-white rounded-xl border border-gray-100 shadow-sm p-5 md:p-6">
    <div class="tw-flex items-center justify-between mb-4">
      <h3 class="text-base font-semibold text-gray-900 m-0">User growth &amp; roles</h3>
    </div>
    <p class="text-sm text-gray-500 mt-0 mb-3">New members joining over time, and the current role distribution.</p>

    <div class="chart-container">
      <div class="chart-main">
        <SimpleLineChart v-if="hasGrowth" :data="chartData"/>
        <div v-else class="text-sm text-gray-400 py-2">No new members yet</div>
      </div>

      <div class="chart-aside">
        <h4 class="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-3">Roles</h4>
        <div class="space-y-2.5">
          <div v-for="role in roles" :key="role.label">
            <div class="tw-flex items-center justify-between text-sm mb-1">
              <span class="text-gray-600 truncate">{{ role.label }}</span>
              <span class="text-gray-400">{{ role.count }}</span>
            </div>
            <div class="h-2 rounded-full bg-gray-100 overflow-hidden">
              <div class="h-full rounded-full bg-primary" :style="{ width: roleWidth(role.count) + '%' }"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { parseChartData } from '../../Chart/chartsMixin.js'
  import SimpleLineChart from '../../Chart/SimpleLineChart.vue'

  export default {
    name: 'HeartbeatUserGrowth',
    components: {
      SimpleLineChart,
    },
    props: {
      users: Object,
    },
    computed: {
      roles () {
        return (this.users && this.users.roles) || []
      },
      rolesMax () {
        return this.roles.reduce((max, role) => Math.max(max, role.count), 0)
      },
      hasGrowth () {
        const perMonth = this.users && this.users.new_users_per_month
        return perMonth && Object.values(perMonth).some(value => value > 0)
      },
      chartData () {
        if (!this.users || !this.users.new_users_per_month) {
          return null
        }

        return parseChartData([{
          color: '#2E59FA',
          label: 'New members',
          cumulate: false,
          data: this.users.new_users_per_month,
        }])
      },
    },
    methods: {
      roleWidth (count) {
        if (!this.rolesMax) {
          return 0
        }

        return Math.max(3, Math.round((count / this.rolesMax) * 100))
      },
    },
  }
</script>
